export const DEFAULT_MIN_AGE = 0;
export const DEFAULT_MAX_AGE = 18;
export const DEFAULT_MAX_CHILD_AGE = 12;
export const DEFAULT_ESCAPADE_MIN_CHILD_AGE = 48;
export const DEFAULT_TOUR_MIN_CHILD_AGE = 84;
